import { colors } from '@ctw/config/zui';
import { effectiveHeadingLevel } from '@ctw/shared/utils/cda/heading-level';
import { textContentFromNodeTree } from '@ctw/shared/utils/cda/helpers';
import type { CdaParsedHtmlElementNode } from '@ctw/shared/utils/cda/types';
import { StyleSheet, Text } from '@react-pdf/renderer';

const baseHeadingStyle = {
  marginBottom: 5,
  marginTop: 5,
};

export const headingStyles = StyleSheet.create({
  headingContentContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  h1: {
    fontSize: 24,
    fontWeight: 600,
    ...baseHeadingStyle,
  },
  h2: {
    fontSize: 17,
    fontWeight: 600,
    ...baseHeadingStyle,
  },
  h3: {
    fontSize: 16,
    fontWeight: 600,
    ...baseHeadingStyle,
  },
  h4: {
    fontSize: 12,
    fontWeight: 600,
    ...baseHeadingStyle,
  },
  h5: {
    fontSize: 10,
    fontWeight: 600,
    ...baseHeadingStyle,
  },
  h6: {
    fontSize: 8,
    fontWeight: 600,
    ...baseHeadingStyle,
  },
  subtitle: {
    fontSize: 10,
    fontStyle: 'italic',
    color: colors.content.subtle,
    paddingTop: 1,
    paddingBottom: 5,
  },
});

interface PdfHeadingRendererProps {
  id: string;
  heading: CdaParsedHtmlElementNode;
}

export const PdfHeadingRenderer = ({ id, heading }: PdfHeadingRendererProps) => {
  const level = effectiveHeadingLevel(heading.nodeName);
  const style = headingStyles[level as never];

  return (
    <Text key={id} style={style} minPresenceAhead={2}>
      {textContentFromNodeTree(heading)}
    </Text>
  );
};
